/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Filter_To_SeparatorInputs */

const en_audit_filter_to_separator = /** @type {(inputs: Audit_Filter_To_SeparatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`to`)
};

const pt_br2_audit_filter_to_separator = /** @type {(inputs: Audit_Filter_To_SeparatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`até`)
};

/**
* | output |
* | --- |
* | "to" |
*
* @param {Audit_Filter_To_SeparatorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const audit_filter_to_separator = /** @type {((inputs?: Audit_Filter_To_SeparatorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Filter_To_SeparatorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_filter_to_separator(inputs)
	return pt_br2_audit_filter_to_separator(inputs)
});